import React from 'react';
import { Box, makeStyles, Typography } from '@material-ui/core';
import CheckCircle from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import LwtTable from 'components/@common/Table/LwtTable';

// import InfoIcon from '@material-ui/icons/Info';
import { PrmStudentCurriculumLessonReportResult } from 'types/schema-generated-types';
import { isNil } from 'lodash';
import useCommonStyles from '../../common/styles';

const Title: any = ({ text }: { text?: any }) =>
  text !== 0 && <Typography style={{ fontSize: 13 }}>{text}</Typography>;

const Label = ({ text }: any) => {
  return (
    <Box display="flex">
      <Typography style={{ fontSize: 12, fontWeight: 600 }}>{text}</Typography>
      {/* <InfoIcon style={{ alignSelf: 'center', marginLeft: 4 }} className={classes.infoIcon} /> */}
    </Box>
  );
};

type Keys = {
  id?: string | number;
  lessonNumber?: string | number;
  lessonSkill?: string | number;
  metSkill?: any;
  averageTime: any;
  usedSupport?: string;
};
const getColumns = () => {
  return [
    {
      id: 'lessonNumber',
      label: 'LESSON NUMBER',
      sortKey: 'lessonNumber',
      // eslint-disable-next-line react/display-name
      getValue(item: Keys) {
        return (
          <div key={`${item.id}_col_1`}>
            <Title text={item.lessonNumber} />
          </div>
        );
      },
      sortable: true
    },
    {
      id: 'lessonSkill',
      label: 'LESSON SKILL',
      sortKey: 'lessonSkill',
      // eslint-disable-next-line react/display-name
      getValue(item: Keys) {
        return (
          <div key={`${item.id}_col_1`}>
            <Title text={item.lessonSkill} />
          </div>
        );
      },
      sortable: true
    },
    {
      id: 'metSkill',
      label: <Label text="LESSON STATUS" />,
      sortKey: 'metSkill',
      // eslint-disable-next-line react/display-name
      getValue(item: Keys) {
        return !isNil(item.metSkill) ? (
          item.metSkill ? (
            <Box display="flex" key={`${item.id}_col_1`}>
              <Title text="Skill Met" />
              <CheckCircle
                fontSize="small"
                style={{ color: '#51A486', fontSize: 14, alignSelf: 'center', marginLeft: 4 }}
              />
            </Box>
          ) : (
            <Box display="flex" key={`${item.id}_col_1`}>
              <Title text="Skill Not Met" />
              <CancelIcon
                fontSize="small"
                color="error"
                style={{ fontSize: 14, alignSelf: 'center', marginLeft: 4 }}
              />
            </Box>
          )
        ) : (
          '--'
        );
      }
    },
    {
      id: 'usedSupport',
      label: <Label text="ADDITIONAL SUPPORT" />,
      sortKey: 'usedSupport',
      // eslint-disable-next-line react/display-name
      getValue(item: any) {
        return !isNil(item.usedSupport) ? (
          <Box display="flex" key={`${item.id}_col_1`}>
            <Title text={item.usedSupport ? 'Yes' : 'No'} />
            {item.usedSupport && (
              <FiberManualRecordIcon
                fontSize="small"
                style={{ fontSize: 14, alignSelf: 'center', color: '#FFC20E', marginLeft: 4 }}
              />
            )}
          </Box>
        ) : (
          '--'
        );
      }
    },
    {
      id: 'averageTime',
      label: <Label text="TIME PER LESSON" />,
      sortKey: 'averageTime',
      // eslint-disable-next-line react/display-name
      getValue(item: Keys) {
        return (
          <div key={`${item.id}_col_1`}>
            {item.averageTime !== '0' ? <Title text={`${item.averageTime} minutes`} /> : '--'}
          </div>
        );
      }
    }
  ];
};

const getData = (studentLessonReport: PrmStudentCurriculumLessonReportResult): any[] => {
  const result = studentLessonReport.lessonDetail?.lessons.map(l => ({
    lessonNumber: l.lesson?.lessonNumber,
    lessonSkill: l.lesson?.primarySkillPhonics || l.lesson?.primarySkillWordStudy,
    usedSupport: l?.usedSupport,
    metSkill: l?.metSkill,
    averageTime: `${Math.round(l?.timeSpentSeconds! / 60)}`
  }));
  return result ?? [];
};
type Props = {
  studentLessonReport: PrmStudentCurriculumLessonReportResult;
};
const SkillProgressTable: React.FC<Props> = ({ studentLessonReport }) => {
  const commonClasses = useCommonStyles();

  const classes = useStyles();
  return (
    <Box className={commonClasses.container}>
      <Box display="flex">
        <Typography style={{ fontWeight: 450, fontSize: 24, paddingBottom: 15 }}>
          Lesson Results
        </Typography>
        {/* <InfoIcon className={classes.infoIcon} /> */}
      </Box>
      <LwtTable
        data={getData(studentLessonReport)}
        columns={getColumns()}
        classes={{ headRow: () => classes.title }}
      />
    </Box>
  );
};

const useStyles = makeStyles(theme => ({
  title: {
    fontSize: 12
  },
  infoIcon: {
    height: 16,
    width: 16,
    paddingTop: theme.spacing() / 2,
    color: theme.palette.secondary.main,
    marginLeft: 8
  }
}));
export default SkillProgressTable;
